import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import SignupDoctor from '../../../../../presentation/pages/doctors/amplify/signup'

import { makeDoctorsRegister } from '../../../../usecases/doctors/remote-doctors-factory'

import { theme } from '../../../../../presentation/styles/theme'

import { STATES, HelperViaCep } from '../../../../../presentation/helpers'
import { RoutesEnum } from '../../../../../presentation/enums'

const MakeSignupDoctor = (): JSX.Element => {
  window.dataLayer.push({
    event: 'signupDoctor',
  })
  document.title = 'Buscar Médicos - Cadastro - Passo 1'

  const history = useHistory()

  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const [zipcode] = useState('')

  const handleCepSelect = async (data: any, el: any) => {
    const numericCep = data.replace(/\D/g, '')
    if (numericCep.length >= 8) {
      const response = await HelperViaCep.getAdressByCep(numericCep)
      el.setFieldValue('city', response?.city ?? '')
      el.setFieldValue('neighborhood', response?.neighborhood ?? '')
      el.setFieldValue('street', response?.street ?? '')
      el.setFieldValue('state', response?.state ?? '')
      el.setFieldValue('city', response?.city ?? '')
    }
  }

  const dataForm = [
    {
      items: [
        {
          component: 'Title',
          title: 'Insira os seus',
          subtitle: 'dados pessoais',
        },
        {
          name: 'firstName',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Primeiro nome',
          label: 'Primeiro nome',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'lastName',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Sobrenome',
          label: 'Sobrenome',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'Subtitle',
          title:
            'Você não poderá utilizar o mesmo e-mail para se cadastrar como contratante!',
          style: { color: `${theme.colors.gray500}` },
        },
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Senha (Mín. 8 caracteres, maiúscula, símbolo e número)',
          label: 'Senha (Mín. 8 caracteres, maiúscula, símbolo e número)',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'confirmPassword',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Confirmar senha',
          label: 'Confirmar senha',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'whatsapp',
          component: 'InputPhone',
          value: '',
          placeholder: 'Digite aqui',
          type: 'tel',
          title: 'WhatsApp',
          label: 'WhatsApp',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'Title',
          title: 'Insira os dados do',
          subtitle: 'CRM',
        },
        {
          name: 'CRM',
          component: 'InputMask',
          mask: 'CRM',
          value: '',
          placeholder: 'Digite aqui',
          type: 'tel',
          title: 'número do CRM',
          label: 'número do CRM',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'uf',
          component: 'InputMask',
          mask: 'UF',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'UF de emissão (Apenas letra maiúscula)',
          label: 'UF de emissão (Apenas letra maiúscula)',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'InputMask',
          mask: 'CPF',
          name: 'cpf',
          title: 'CPF',
          label: 'CPF',
          type: 'tel',
          value: '',
          required: true,
          validations: 'inputRequired',
          placeholder: 'Digite aqui',
        },
        {
          component: 'InputMask',
          mask: 'DATE',
          name: 'birthDay',
          type: 'tel',
          title: 'Data de nascimento',
          label: 'Data de nascimento',
          value: '',
          required: true,
          validations: 'inputRequired',
          placeholder: 'Digite aqui',
        },
        {
          component: 'Title',
          title: 'Insira seu',
          subtitle: 'endereço',
        },
        {
          component: 'InputMask',
          mask: 'CEP',
          name: 'zipcode',
          label: 'Informe o CEP',
          title: 'Informe o CEP',
          type: 'tel',
          value: zipcode,
          required: true,
          placeholder: 'Digite aqui',
          validations: 'inputRequired',
          onChange: handleCepSelect,
        },
        {
          name: 'street',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Rua',
          label: 'Rua',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'number',
              component: 'InputMask',
              mask: 'ONLY_NUMBERS',
              value: '',
              placeholder: 'Digite aqui',
              type: 'tel',
              title: 'Número',
              label: 'Número',
            },
            {
              name: 'neighborhood',
              component: 'Input',
              value: '',
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Bairro',
              label: 'Bairro',
              required: true,
              validations: 'inputRequired',
            },
          ],
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'city',
              component: 'Input',
              value: '',
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Cidade',
              label: 'Cidade',
              required: true,
              validations: 'inputRequired',
            },
            {
              component: 'Select',
              title: 'Estado',
              label: 'Estado',
              name: 'state',
              required: true,
              placeholder: 'Selecione seu Estado',
              options: STATES.map((option) => ({
                label: option.name,
                value: option.uf,
              })),
            },
          ],
        },
        {
          name: 'complement',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Complemento',
          label: 'Complemento',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (values: any): Promise<void> => {
    if (values.password !== values.confirmPassword) {
      setErrorMessage('As senhas não coincidem.')
      return
    }

    const cpfWithoutSpecialChars = values.cpf.replace(/[^\d]/g, '')

    try {
      const response = await makeDoctorsRegister('step-one').post({
        email: values.email,
        password: values.password,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.whatsapp,
        crm: {
          crm: values.CRM,
          uf: values.uf,
          numeroCPF: cpfWithoutSpecialChars,
          dataNascimento: values.birthDay,
        },
        address: {
          zipcode: values.zipcode,
          street: values.street,
          number: values.number,
          neighborhood: values.neighborhood,
          city: values.city,
          state: values.state,
          complement: values.complement,
        },
      })
      localStorage.setItem('userEmail', values.email)
      if (response.nextRegister) {
        history.push(`/${response.nextRegister}/doctor`)
      } else {
        history.push(RoutesEnum.SIGNUP2_DOCTOR)
      }
    } catch (error: any) {
      toast.error(error.message, {
        autoClose: 10000,
      })
    }
  }

  return (
    <SignupDoctor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeSignupDoctor
